import { render, staticRenderFns } from "./salary-field.vue?vue&type=template&id=37ebb008"
import script from "./salary-field.vue?vue&type=script&lang=js"
export * from "./salary-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports